/**
 * @file automatically generated from MApp.Endpoints.ServerController
 */

import { MetadataClient } from '../metadata-client';
import { ILatestVersion } from '../models';

export class ServerClient extends MetadataClient {

	public static getCurrentVersion(requestInit?: RequestInit) {
		return MetadataClient.ajax<string>(
			new Request(MetadataClient.endpointsUrl + `api/v1/server/currentversion`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getLatestVersion(requestInit?: RequestInit) {
		return MetadataClient.ajax<ILatestVersion>(
			new Request(MetadataClient.endpointsUrl + `api/v1/server/latestversion`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}
}
